import { render, staticRenderFns } from "./RechargeItems.vue?vue&type=template&id=2a8d9cde&scoped=true"
import script from "./RechargeItems.vue?vue&type=script&lang=js"
export * from "./RechargeItems.vue?vue&type=script&lang=js"
import style0 from "./RechargeItems.vue?vue&type=style&index=0&id=2a8d9cde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8d9cde",
  null
  
)

export default component.exports